exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#SettingsSnapWrapper .v-list__tile{height:auto!important}#SettingsSnapWrapper #main__wrapper{padding-top:30px}#SettingsSnap .v--modal-box.v--modal{min-height:200px!important;min-width:500px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e102f070","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/edition/modals/SettingsSnap.vue
// module id = 2143
// module chunks = 0